// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://i9s02d21zj.execute-api.eu-west-1.amazonaws.com/dev/',
  wsUrl: 'wss://5q6ptz1y96.execute-api.eu-west-1.amazonaws.com/dev',
  auth: {
    domain: 'dev-16x5l1ey.eu.auth0.com',
    clientId: 'REYyY7MhmoG8u9rYLsQtnIUZiCUzQ26n',
    redirectUri: window.location.origin,
    identifier: 'https://dev-16x5l1ey.eu.auth0.com/api/v2/'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
